/* Placeholder "AI-generated" gradient images, identical to the approved prototype.
   Swap for the real image-generation endpoint when the backend ships. */
const GRADIENTS = [
  ['#186338', '#4fa472'],
  ['#2a78d6', '#86b6ef'],
  ['#c08a2d', '#eda100'],
  ['#7a3a8a', '#ba7aca'],
  ['#2d5c2e', '#77b691'],
  ['#c2703f', '#f0a060'],
  ['#3a7ca5', '#7ec8e3'],
  ['#a83f34', '#e8a99f'],
];

export function mockAIImage(seed) {
  const g = GRADIENTS[seed % GRADIENTS.length];
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><defs><linearGradient id='g' x1='0' y1='0' x2='1' y2='1'><stop offset='0' stop-color='${g[0]}'/><stop offset='1' stop-color='${g[1]}'/></linearGradient></defs><rect width='200' height='200' fill='url(#g)'/><text x='100' y='118' font-size='58' text-anchor='middle' fill='%23ffffffcc' font-family='Georgia,serif'>✨</text></svg>`;
  return 'data:image/svg+xml;utf8,' + encodeURIComponent(svg);
}

export const GALLERY_SIZE = 8;
